import { $, $$ } from '@utils';
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination, EffectFade, A11y } from 'swiper/modules';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

function init() {
  if (!$('[data-au-login-com]')) return;

  buildSlider();
  datalayerLogin();
}

function buildSlider() {
  const slider = $('[data-au-login-com-swiper]');
  new Swiper(slider, {
    modules: [Autoplay, Navigation, Pagination, EffectFade, A11y],
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    pagination: {
      el: '[data-au-login-com-swiper-pagination]',
      bulletClass: 'au-login-com__step',
      bulletActiveClass: 'au-login-com__step--active',
      clickable: true,
    },
    slidesPerView: 1,
    a11y: {
      enabled: true,
      slideRole: null,
    },
  });
}

function datalayerLogin() {
  $$('[data-au-datalayer-login-submmit]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      const el = e.currentTarget;
      const titleText = el.closest('[data-au-login-com]').querySelector('[data-au-login-com-form-title]').innerText;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickBoton',
        item_id,
      });
    });
  });

  const linkRecover = $('[data-au-datalayer-login-link]');

  if (linkRecover) {
    linkRecover.addEventListener('click', (e) => {
      e.preventDefault();
      const el = e.currentTarget;
      const titleText = el.closest('[data-au-login-com]').querySelector('[data-au-login-com-form-title]').innerText;
      const clickText = el.querySelector(':not([data-au-icon])').innerText;
      const item_id = `${removeAccentMarkAndUppercase(titleText)}_${removeAccentMarkAndUppercase(clickText)}`;

      window.dataLayer.push({
        event: 'navigation',
        content_type: 'clickEnlace',
        item_id,
      });
    });
  } else {
    return;
  }
}

export default { init };
